import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { Box } from '@/components/blocks/Box';
import { MenuList } from '@/components/pages/Home/MenuList';
import { AppPromotion } from '@/components/partials/AppPromotion';
import { useFeatureFlag } from '@/hooks/graphql/use-feature_flag';
import { theme } from '@/styles/theme';
import { publicPath } from '@/utils/path';

const Root = styled(Box)(() =>
  css({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    cursor: 'pointer',
  })
);

export const Home = () => {
  const router = useRouter();
  const liffId = router.query.liffId as string;
  const { isEnabled: displayQrCode, loading: displayQrCodeLoading } =
    useFeatureFlag('Issue12436-display_qr_code');

  const handleClick = useCallback(
    async (pathname: string) => {
      await router.push({
        pathname: `/${liffId}/${pathname}`,
      });
    },
    [liffId, router]
  );

  return (
    <Root>
      <MenuList
        title='処方箋ネット受付'
        description='事前に処方箋を送信して待ち時間を短縮'
        icon='send'
        onClick={async () => {
          await handleClick('reception/organizations');
        }}
      />
      <MenuList
        title='Web問診'
        description='お使いのスマホから簡単に回答'
        icon='clipboard'
        onClick={async () => {
          await handleClick('outpatient_questionnaire/organizations');
        }}
      />
      {!displayQrCodeLoading && displayQrCode && (
        <MenuList
          title='QRコード読み取り'
          description='患者情報を薬局に送信'
          icon='qrcode'
          onClick={async () => {
            await handleClick('connection_request');
          }}
        />
      )}
      <MenuList
        title='患者設定'
        description='家族の追加や修正はここから'
        icon='user-group'
        onClick={async () => {
          await handleClick('patient');
        }}
      />
      <Box marginTop='auto' padding={theme.spaces.l}>
        <AppPromotion
          bannerPath={{
            smartphone: publicPath('/img/bnr-app-sp-patient.png'),
            tablet: publicPath('/img/bnr-app-tb-patient.png'),
          }}
        />
      </Box>
    </Root>
  );
};
